import { Flex } from "styles/utility-components";

import Spinner from "components/ui/spinner/Spinner";

export default function CentredSpinner({ label }: { label?: string }): JSX.Element {
  return (
    <Flex alignItems="center" justifyContent="center" width="100%" height="100%">
      <Spinner size="size32" label={label} />
    </Flex>
  );
}
